export default __webpack_public_path__ + "static/media/logo.aa4e7702.svg";